import { useIonModal, useIonToast } from '@ionic/react';
import { FullComment, calcDateSpanDescription } from 'model';
import { useState } from 'react';
import { useReportCommentMutation, useUnReportCommentMutation } from '../api/ReportApi';
import { ReportValuesType, UIReportReasons } from '../model/report';
import { Confirmation } from '../pages/Confirmation';
// eslint-disable-next-line css-modules/no-unused-class
import sharedstyles from '../styles/Shared.module.css';
import { Select } from './Forms/Select';
import { IconButton } from './IconButton';
import { PostContentsToHTML } from './PostContentsToHTML';
import { ProfilePic } from './ProfilePic';
import { IconReport, IconReportSolid } from './QuirkIcons';
import { TruncatedSummary } from './TruncatedSummary';
interface reportCommentType {
	comment: FullComment;
	hideTooltip?: () => void;
	label?: boolean;
	isReported: boolean;
}
export const ReportComment: React.FC<reportCommentType> = ({ comment, hideTooltip, label, isReported }) => {
	const [reportValues, setReportValues] = useState<ReportValuesType>({ document: comment._id, reason: 'offensive' });
	const [presentReported] = useIonToast();
	const [reportComment] = useReportCommentMutation();
	const [unReportComment] = useUnReportCommentMutation();
	const [localFlip, setLocalFlip] = useState(isReported);

	const handleReportComment = async () => {
		dismiss();
		setLocalFlip(!localFlip);
		if (isReported) {
			presentReported({
				color: 'success',
				message: 'Comment has been un-reported',
				position: 'top',
				duration: 1500
			});
			await unReportComment({ document: comment._id });
		} else {
			presentReported({
				color: 'danger',
				message: 'Comment has been reported',
				position: 'top',
				duration: 1500
			});
			await reportComment(reportValues);
		}
		hideTooltip && hideTooltip();
	};

	const engage = () => {
		!isReported ? present() : handleReportComment();
	};

	const [present, dismiss] = useIonModal(Confirmation, {
		onDismiss: () => dismiss(),
		action: handleReportComment,
		cancelAction: hideTooltip,
		actionLabel: 'Report',
		dismissLabel: 'Cancel',
		content: (
			<>
				<div className={sharedstyles.userContainer}>
					<ProfilePic user={comment.fullAuthor} />
					<div className="fullwidth">
						<div className={sharedstyles.name}>{comment.fullAuthor.username}</div>
						<div className={sharedstyles.time}>{calcDateSpanDescription(comment?.fullAuthor.updated)}</div>
					</div>
				</div>
				<h5>Are you sure you want to report this comment?</h5>
				<div className="space10" />
				<Select
					id="reason"
					placeholder="Select Reason"
					label="Select Reason"
					value={reportValues.reason}
					name="reason"
					options={UIReportReasons}
					onChange={e => {
						setReportValues({
							...reportValues,
							reason: e.detail.value
						});
					}}
				/>
				<div className="space20" />
				<TruncatedSummary>
					<PostContentsToHTML>{comment.comment}</PostContentsToHTML>
				</TruncatedSummary>
			</>
		)
	});

	return (
		<IconButton
			label={label ? (isReported ? 'Unreport' : 'Report') : ''}
			icon={localFlip ? <IconReportSolid /> : <IconReport />}
			onClick={engage}
		/>
	);
};
